const countDown = {
  messageElement: document.getElementById("countDown"),
  message: "",
  showCountdown: true,
  options: {
    timeZone: "Australia/Brisbane",
  },
  init() {
    if (!this.messageElement) return;
    this.updateMessage();
    setInterval(() => this.updateMessage(), 1000);
  },
  getFormatedDate() {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-AU", {
      ...this.options,
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      weekday: "long",
    });

    return formatter.formatToParts(now);
  },
  updateMessage() {
    this.showCountdown = true;
    const formattedDate = this.getFormatedDate();

    let day = formattedDate.find((part) => part.type === "weekday").value;
    let hour = parseInt(
      formattedDate.find((part) => part.type === "hour").value,
      10
    );

    if (
      ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].includes(day)
    ) {
      if (hour >= 0 && hour < 12) {
        this.calcTime();
      } else if (hour >= 12 && hour < 24) {
        this.message =
          "Same-day dispatch will be available start of next day until 12:00pm!";
      }
    }

    if (day === "Friday" && hour >= 12) {
      this.message = "";
      this.showCountdown = false;
    }

    if (["Saturday", "Sunday"].includes(day)) {
      this.message = "";
      this.showCountdown = false;
    }
    this.setMessage();
  },
  setMessage() {
    if (!this.showCountdown) {
      this.messageElement.style.display = "none";
    } else {
      this.messageElement.style.display = "block";
      this.messageElement.textContent = this.message;
    }
  },
  calcTime() {
    const now = new Date(new Date().toLocaleString("en-US", this.options));
    const targetTime = new Date(now);
    targetTime.setHours(12, 0, 0, 0);
    let timeDiff = targetTime - now;
    let hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
    let minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    let secondsLeft = Math.floor((timeDiff % (1000 * 60)) / 1000);

    const countdownText = `${hoursLeft}h ${minutesLeft}m ${secondsLeft}s`;
    this.message = `Order in ${countdownText} to qualify for same-day pack-out!`;
  },
};

export default countDown;
